import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { getTourSequences } from './get-tour-sequences.action';

export const deleteTourSequence = createAppAsyncThunk(
  'projectTourOntour/deleteTourSequence',
  async (
    id: number,
    { extra: { projectTourOntourGateway, snackbarGateway }, dispatch },
  ): Promise<void> => {
    try {
      await projectTourOntourGateway.deleteSequence(id);
      await dispatch(getTourSequences());
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('DeleteTourSequence.Message.success'));
}

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('DeleteTourSequence.Message.error'));
}
